import type User from "@/data/models/User";
import type { Role } from "@/data/models/User";
import { generateRandomUuid } from "@/utils/Utils";

/**
 * Builds the effective user stored during master->member switched sessions.
 * Prefers the real source user identity to preserve capability behavior.
 */
export function buildSwitchedSessionUser(
  sourceUser: User | null,
  fallbackUserId?: string | null,
  fallbackRole?: Role | null,
) {
  if (sourceUser?.id) {
    return {
      ...sourceUser,
      hasEnabledCockpit: sourceUser.hasEnabledCockpit ?? true,
    } as User;
  }

  return {
    id: fallbackUserId ?? generateRandomUuid(),
    role: (fallbackRole ?? "ADMIN") as Role,
    wasSetToAdmin: true,
    hasEnabledCockpit: true,
    nickname: "Master",
  } as User;
}
